/**
 * Defines the priority of the message for delivery.
 * Setting higher priority increases the chance of the message to be delivered
 * but may cause performance issues or duplications.
 */
export var PulseMessagePriority;
(function (PulseMessagePriority) {
    /**
     * The default priority level. Message waits for it's turn to be delivered.
     */
    PulseMessagePriority[PulseMessagePriority["Normal"] = 1] = "Normal";
    /**
     * Flush the queue and sent to the server
     * immediately unless prevented by the consent checks.
     */
    PulseMessagePriority[PulseMessagePriority["High"] = 2] = "High";
    /**
     * Ignores consent checks and immediately send
     * all the queued messages to the server.
     */
    PulseMessagePriority[PulseMessagePriority["Force"] = 3] = "Force";
})(PulseMessagePriority || (PulseMessagePriority = {}));
export var BuiltinEvents;
(function (BuiltinEvents) {
    BuiltinEvents["NAVIGATION"] = "navigation";
    BuiltinEvents["CLICK"] = "click";
    BuiltinEvents["POPUP"] = "popup";
    BuiltinEvents["CONTEXTMENU"] = "contextmenu";
    BuiltinEvents["CONSENT_CHANGE"] = "consent_change";
    BuiltinEvents["SESSION_START"] = "session_start";
})(BuiltinEvents || (BuiltinEvents = {}));
//# sourceMappingURL=event.js.map